import { StateNode } from '@ansys-internal/awf-angular/store';

export class ActiveConceptIDState implements StateNode<string> {
  key: string = 'activeConceptID';
  mutable: boolean = true;
  observeInitial: boolean = true;
  defaultValue: () => string = () => '';
}
